import React, {Component} from 'react';
import {inject, observer} from "mobx-react";
import {renderToString} from "react-dom/server";
import moment from "moment";
import {api} from "../../../../services";
import {
  MarkerEmptyIcon,
  MarkerOverRpmIcon,
  MarkerTripEndIcon,
  MarkerTripStartIcon,
  WarningIcon
} from "../../../../common/icons";
import hereHelper from "../../../../helpers/hereHelper";
import HereService from "../../../../services/Here";
import NoteInput from "../TripItem/NoteInput";
import PositionsDetail from "../TripItem/PositionsDetail";
import DetailItem from "../TripItem/DetailItem";

import './TripDetail.css'
import TripMap from "./TripMap";
import OverRpmsChart from "./OverRpmsChart";

@inject('translationsStore', 'tripsStore')
@observer
export default class TripDetail extends Component
{
  constructor(props) {
    super(props);

    this.MarkerEmptyIcon = renderToString(<MarkerEmptyIcon />);
    this.TripStartIcon = renderToString(<MarkerTripStartIcon style={{ color: 'var(--engine-on)' }} />);
    this.TripEndIcon = renderToString(<MarkerTripEndIcon style={{ color: 'var(--engine-off)' }} />);
    this.OverRpmIcon = renderToString(<MarkerOverRpmIcon />);

    this.state = {
      address1: '',
      address2: '',
      hasValidPosition: true,
      crashEvents: 0,
      positions: [],
      overRpmsWithPositions: [],
      showRpmsChart: false
    };
  }

  matchroute() {
    if (this.props.positions && this.props.positions.length > 0) {
      this.setState({ positions: this.props.positions });

      const gpx = hereHelper.buildGpxForMatchroute(this.props.positions);
      return new HereService()
        .matchroute(gpx)
        .then(hereHelper.getPositionsFromMatchrouteResponse)
        .then(positions => new Promise(resolve => this.setState({ positions }, resolve)));
    } else {
      return new Promise(resolve => this.setState({ positions: [] }, resolve));
    }
  }

  loadRpms = () => {
    const { startAt, endAt } = this.props.trip;
    api('getRpm', this.props.trip.carId, moment(startAt).format('YYYY-MM-DD'), moment(endAt ? endAt : startAt).format('YYYY-MM-DD'))
      .then(rawOverRpms => {
        return rawOverRpms;
      })
      .catch(() => {})
      .then(rawOverRpms => {
        const overRpms = rawOverRpms.rpms.filter(rpm => rpm.startDateTime >= startAt && rpm.endDateTime <= endAt);
        let overRpmsWithPositions = overRpms;
        const positions = this.props.trip.positions.map(position => position.loc);
        overRpmsWithPositions = overRpmsWithPositions.map(overRpm => {
          const {
            coordinates: [startPosition_lng, startPosition_lat]
          } = overRpm.startPosition;
          const {
            coordinates: [endPosition_lng, endPosition_lat]
          } = overRpm.endPosition;
          return {
            ...overRpm,
            startPosition: { lat: startPosition_lat, lng: startPosition_lng },
            endPosition: { lat: endPosition_lat, lng: endPosition_lng }
          };
        });

        this.setState({
          overRpmsWithPositions
        });
      });
  }

  componentDidMount = () => {
    //current.wrappedInstance if the component is wrapped by the mobx injector
    // this.MapInstace = this.MapRef.current.wrappedInstance;
    this.matchroute();
    this.loadRpms();
    this.setCrashEvents();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.index !== this.props.index) {
      this.matchroute();
    }
  };

  getAlarmsCount = () => {
    const {trip} = this.props;
    return (
      Number(trip.accelerations) +
      Number(trip.brakes) +
      Number(trip.leftTurns) +
      Number(trip.rightTurns) +
      Number(trip.overDrives) +
      Number(this.state.overRpmsWithPositions.length) +
      Number(this.state.crashEvents)
    );
  }

  setCrashEvents = () => {
    const {
      trip: { startAt, endAt, car }
    } = this.props;
    const startTime = startAt ? startAt : new Date().toISOString(),
      endTime = endAt ? endAt : new Date().toISOString();
    let crashEvents;
    api('getCarCrashEvents', car.plate, startTime, endTime)
      .then(response => {
        crashEvents = response.count;
      })
      .catch(() => {
        crashEvents = 0;
      })
      .finally(() => {
        this.setState({ crashEvents });
      });
  };

  markersMapper = (marker, index) => {
    const [lng, lat] = marker.coordinates;
    let markerData = {
      icon: marker.theme === 'start' ? this.TripStartIcon : marker.theme === 'end' ? this.TripEndIcon : marker.theme === 'overrpm' ? this.OverRpmIcon : this.MarkerEmptyIcon,
      lng,
      lat,
      id: marker.id
    };
    return markerData;
  };

  handleNoteChange = (note) => {
    const trip = {...this.props.trip, note};
    this.props.tripsStore.updateTrip(trip)
  }

  render(){
    const { trip, translationsStore } = this.props;
    const { hasValidPosition, crashEvents, positions, overRpmsWithPositions } = this.state;

    let start = (positions && positions[0]) || [0, 0];
    let end = (positions && positions[positions.length - 1]) || [0, 0];

    let markers = [{ id: 0, theme: 'start', coordinates: start }, { id: 1, theme: 'end', coordinates: end }];
    overRpmsWithPositions.forEach(over => {
      const {
        startPosition: { lat, lng }
      } = over;
      markers.push({ id: markers.length, theme: 'overrpm', coordinates: [lng, lat] });
    });

    return(
      <div className="TripDetail">
        <div className="TripItem">
          <div className="TripTitle">
            <div className="TripDate">
              {`${new Date(trip.startAt).toLocaleDateString()} (${new Date(trip.startAt).toLocaleTimeString([], {timeStyle: 'short'})} ${trip.endAt ? ` - ${new Date(trip.endAt).toLocaleTimeString([], {timeStyle: 'short'})}` : ''})`}
            </div>
            <NoteInput value={trip.note} onChange={this.handleNoteChange} />
          </div>
          <div className="TripDetails">
            <PositionsDetail trip={trip} />
            <DetailItem label={translationsStore.translate('tripsList.detail.time')} value={moment.duration(trip.duration || 0, 'seconds').format('h:mm:ss [h]', { trim: false })} />
            <DetailItem label={translationsStore.translate('tripsList.detail.distance')} value={`${trip.distance} km`} />
            <DetailItem label={translationsStore.translate('tripsList.detail.vehicle')} value={trip.car.plate} />
          </div>
          <div className="TripDetails">
            <DetailItem label={translationsStore.translate('tripsList.detail.alerts')} value={<div style={{color: '#ff5d58', display: 'flex'}}><WarningIcon style={{fontSize: 18, marginRight: 5}} />{this.getAlarmsCount()}</div>} />
            <DetailItem label={'Accelerazioni'} value={Number(trip.accelerations)} />
            <DetailItem label={'Frenate'} value={Number(trip.brakes)} />
            <DetailItem label={'Cornering'} value={Number(trip.leftTurns) + Number(trip.rightTurns)} />
            <DetailItem label={'Over Rpm'} value={Number(trip.overDrives)} />
            <DetailItem label={'Over Speed'} value={Number(this.state.overRpmsWithPositions.length)} />
            <DetailItem label={'Crash'} value={Number(this.state.crashEvents)} />
          </div>
        </div>
        <div className="map">
          <TripMap trip={trip} />
        </div>
        <OverRpmsChart visible={this.state.showRpmsChart} onClose={() => this.setState({showRpmsChart: false})} trip={trip} overRpms={this.state.overRpmsWithPositions} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripDetail/TripDetail.js